import React from 'react';
import FailedInvoices from '../../billing/FailedInvoices';

const FailedTab = () => <FailedInvoices />;

export default FailedTab;
